const globalListeners = new Map();
class MessageChannel {
    constructor() {
        this.listeners = new Map();
    }
    subscribe(eventName, callback) {
        var _a, _b;
        if (!globalListeners.has(eventName)) {
            globalListeners.set(eventName, []);
        }
        if (!this.listeners.has(eventName)) {
            this.listeners.set(eventName, []);
        }
        // The callback is added to the global listeners so that other instances can publish to all
        // consumers.
        (_a = globalListeners.get(eventName)) === null || _a === void 0 ? void 0 : _a.push(callback);
        // It is also added to a local isteners list to keep track of this instance's listeners.
        (_b = this.listeners.get(eventName)) === null || _b === void 0 ? void 0 : _b.push(callback);
    }
    unsubscribe(eventName, callback) {
        var _a, _b;
        if (!globalListeners.has(eventName)) {
            return;
        }
        const index = (_a = globalListeners.get(eventName)) === null || _a === void 0 ? void 0 : _a.indexOf(callback);
        if (index !== undefined && index > -1) {
            (_b = globalListeners.get(eventName)) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
        }
    }
    /**
     * Unsubscribe all listeners that have been added by this instance
     */
    unsubscribeAll() {
        this.listeners.forEach((callbacks, eventName) => {
            callbacks.forEach((callback) => {
                this.unsubscribe(eventName, callback);
            });
        });
        this.listeners.clear();
    }
    send(eventName, ...args) {
        var _a;
        const listeners = [...((_a = globalListeners.get(eventName)) !== null && _a !== void 0 ? _a : [])];
        listeners.forEach((callback) => {
            callback(...args);
        });
    }
}
export default function useMessageChannel() {
    return new MessageChannel();
}
